module.exports = {
          srcSet: __webpack_public_path__ + "da69e120.jpg"+" 700w"+","+__webpack_public_path__ + "8b53acdf.jpg"+" 1400w"+","+__webpack_public_path__ + "07a8af41.jpg"+" 1545w",
          images:[ {path: __webpack_public_path__ + "da69e120.jpg",width: 700,height: 464},{path: __webpack_public_path__ + "8b53acdf.jpg",width: 1400,height: 928},{path: __webpack_public_path__ + "07a8af41.jpg",width: 1545,height: 1024}],
          src: __webpack_public_path__ + "da69e120.jpg",
          toString:function(){return __webpack_public_path__ + "da69e120.jpg"},
          
          width: 700,
          height: 464
        }